import { defineMessages } from 'react-intl';

const trns = defineMessages({
  cabinet: {
    id: 't0CE6l',
    defaultMessage: 'Кабінет'
  },
  favorites: {
    id: '6JJmNB',
    defaultMessage: 'Обране'
  },
  list: {
    id: '/88hBL',
    defaultMessage: 'Список'
  },
  cart: {
    id: 'FobqBF',
    defaultMessage: 'Кошик'
  },
  myBooking: {
    id: '4jKM2W',
    defaultMessage: 'Мoї бронювання'
  },
  myProfile: {
    id: 'lRzUyb',
    defaultMessage: 'Дані користувача'
  },
  myPharmacies: {
    id: 'IAalxP',
    defaultMessage: 'Мoї аптеки'
  },
  signInUp: {
    id: '7nmXs8',
    defaultMessage: 'вхід / реєстрація'
  }
});

export default trns;
